module.exports = __webpack_public_path__ + "imgs/gift-bow-open.97a023ca4472f17d94a8d099f3382edb.svg";